<template>
  <div class="page" v-wechat-title="$route.meta.title='评论'">
    <div class="container border-box">
      <p class="select-more-comment border-box">全部评论{{total}}条</p>
      <!--新增底部评论详情列表-->
      <div class="comments-list border-box account-list-sr">
        <div v-for="(item,index) in root" :key="index" class="comments-list-data box border-box">
          <p class="block head-img-box">
            <img class="img" v-lazy="item.rzimg?item.rzimg:item.headimg"  :key="index"/>
          </p>
          <div class="flex comments-list-info  border-box">
            <div class="comments-person-box box ">
              <div class="block comments-person">
                <p class="comments-person-name hide">{{item.name}}</p>
                <p class="star-level">
                  <template v-for="(star,index) in [2,4,6,8,10]">
                    <img v-if="item.score>=star" src="../../assets/icon_com.png"/>
                    <img v-else  src="../../assets/start_nor.png" />
                  </template>
                  <span class="icon-reward-small">赏</span>
                </p>
              </div>
              <p @click="uploadZan(index)" class="praise">
                <span>{{item.totalZan}}</span>
                <img v-if="item.iszan==1" src="../../assets/zan_already.png" />
                <img v-else src="../../assets/zan_already_no.png" />
              </p>
            </div>

            <div class="comments-detail border-box">
              <p class="comments-detail-top">{{item.content}}</p>
            </div>

            <div v-if="item.allimg" class="comments-img box border-box">
              <img v-for="(ite,index) in item.allimg"  @click="seeImg(index,item.allimg)" v-lazy="ite"  :key="index"/>
            </div>

            <div class="block comments-person-time">
              {{item.addtime}}
              <!--<span @click="replay" class="comments-person-hf fr"><img src="../../assets/icon_play_btn11.png" />回复</span>-->
              <span v-if="item.state==2" class="shz-text fr none">审核中</span>
            </div>

            <div v-if="item.replys" class="comments-detail-replay border-box">
              <div v-for="(item,index) in item.replys" :key="index" class="comments-replay-text">
                <span>{{item.bagname}}</span> 回复
                <span>{{item.name}}</span> ：{{item.content}}
              </div>
            </div>

            <div class="block-chain" v-if="item.code===0">
              <h3>所在区块信息</h3>
              <p>区块高度：{{item.blockNumber}}</p>
              <p>创建时间：{{item.txTime}}</p>
              <p>哈希值：<font class="p1">{{item.dataHash}}</font></p>
              <img src="../../assets/icon_36.png" alt="">
            </div>

          </div>
        </div>

        <p class="load-tip" ref="loadtip">{{loadText}}</p>
      </div>
    </div>

    <div class="comment-btn-box">
      <p @click="commentsShow" class="comment-btn">我要评论</p>
    </div>

    <!--新版本评论弹窗8-21-->
    <AlertComment :bagInfo="bagInfo" :class="{'curr':commentShow==1,'none':commentShow!=1}"  @child-Comment="closeComment"></AlertComment>


    <!--&lt;!&ndash;导游回复&ndash;&gt;-->
    <!--<view class="alert-box {{replayState == 0 ? 'none' : ''}}">-->
      <!--<view class="mask" bindtap="replayAlert"></view>-->
      <!--<view class="alert-box-form border-box">-->
        <!--<img bindtap="replayAlert" class="icon_close" src="../imgs/icon_close.png"></img>-->
        <!--<view class="font28 cor6 tc">回复内容</view>-->
        <!--<textarea bindinput='inputreplay' value='{{inputvalue}}' class="font20 cor6 border-box" placeholder=""/>-->
        <!--<view bindtap="uploadreplay" class="btn_submit font28 corF tc">提交</view>-->
      <!--</view>-->
    <!--</view>-->


  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import AlertComment from '../../components/AlertComment'
  import {getBagComment, getZan} from "@/service/getData";
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import {wxImgPreview,wxShareme} from '@/utils/wechat'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        spotid: '', //景点id
        shopid: '', //景区id
        id: '', //专辑id
        userInfo: {}, //用户信息
        page: 1,
        rows: 10,
        loadText: "数据加载中",

        root:'',//评论列表
        total:'',//评论总条数

        bagInfo: {},
        isbuy: 0,
        isguide: 0,
        commentShow:0,//评论弹窗

        TimeStamp: new Date().getTime(),  //获取当前时间
      }
    },
    computed: {

    },
    created(){

      this.$loading.show('数据加载中');

      this.id = this.$route.query.id;
      this.isbuy = this.$route.query.isbuy;
      this.isguide = this.$route.query.isguide;
      this.userInfo = getStore("userInfo");
      this.bagInfo = getStore("bagInfo");
      console.log(this.bagInfo)

      this.initData(this.page);

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {
      //获取语音+景区+推荐信息
      async initData(page){
        let res = await getBagComment({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: page,
          rows: this.rows,
          bagid: this.id
        });
        console.log(res.data);

        if (res.errcode === "00000"){
          this.$loading.hide();

          console.log(res)

          this.total = res.data.total
          let root = res.data.root
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      //用户评论点赞
      async uploadZan(index){
        let res = await getZan({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          commentid:this.root[index].id
        });
        if(res.errcode == "00000"){
          this.root[index].totalZan++;
          this.root[index].iszan = 1;
          this.$toast("点赞成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      },

      //评论弹窗显示隐藏
      commentsShow(){
        if(this.isbuy == "false" || this.isbuy == false){
          this.$toast('请先购买')
        }else{
          this.commentShow = 1
        }
      },

      //评论弹窗隐藏
      closeComment :function(msg){
        this.commentShow = msg.commentShow;
        if(msg.success){
          this.page = 1;
          this.root = [];
          console.log(this.page);
          this.initData(this.page);
        }
      },

      //图片预览
      seeImg(ind,imgs){
        wxImgPreview(imgs[ind],imgs);
      }

    },
    components: {
      AlertComment
    },

  }

</script>

<style scoped>
  .container{padding:0!important;background:#fff;}
  .select-more-comment{width:100%;height:.60rem;line-height:.60rem;padding:0 .24rem;font-size:.28rem;color:#333;background:#f6f6f6;}
  .comment-btn-box{position:fixed;left:0;bottom:0;z-index:2;height:1.20rem;width:100%;background:#fff;}
  .comment-btn{position:absolute;left:.24rem;right:.24rem;top:50%;height:.70rem;line-height:.70rem;margin-top:-.35rem;color:#fff;background:#faaf39;border-radius:.30rem;text-align:center;letter-spacing:.05rem;font-size:.32rem;}
</style>



// WEBPACK FOOTER //
// src/page/comment/comment.vue